var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_777",
    "data-name": "Group 777",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.31,
    height: 36.31,
    viewBox: "0 0 36.31 36.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M367.077,243.033a18.155,18.155,0,1,0,18.154,18.156A18.157,18.157,0,0,0,367.077,243.033Zm-4.1,26.07h-3.516v-11.3h3.516Zm-1.758-12.838a2.036,2.036,0,1,1,2.036-2.038A2.037,2.037,0,0,1,361.221,256.266Zm14.91,12.838h-3.509v-5.492c0-1.311-.025-3-1.824-3-1.828,0-2.107,1.428-2.107,2.9V269.1h-3.509v-11.3h3.367v1.545h.046a3.694,3.694,0,0,1,3.325-1.825c3.555,0,4.211,2.338,4.211,5.38Z",
    transform: "translate(-348.921 -243.033)",
    fill: "#2979ff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e567fa6419b29db23c42ff2497765473.svg";
export { ForwardRef as ReactComponent };